export default __webpack_public_path__ + "static/media/enter_otp.87cff4a5.gif";